<template>
  <div class="d-flex gap-2 align-items-center">
    <i
      :id="`${id}-tooltip`"
      class="float-end input-tooltip-btn"
      :class="{
        'icon-outline_info': !isHover,
        'icon-fill_info': isHover,
      }"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    ></i>

    <b-tooltip :target="`${id}-tooltip`" triggers="hover" :placement="placement">
      {{ tooltip }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'right',
    },
  },
  data() {
    return {
      isHover: false,
    }
  },
}
</script>
